module.exports = __webpack_public_path__ + "static/media/icon_faq.d6e292d1.svg";